import { render, staticRenderFns } from "./AccountStatementSales.vue?vue&type=template&id=5cc598aa&"
import script from "./AccountStatementSales.vue?vue&type=script&lang=js&"
export * from "./AccountStatementSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports